import * as React from 'react'

import { cn } from '@/lib/utils'

import OptionsBody from './OptionsBody'
import OptionsHeader from './OptionsHeader'
import OptionsItemList from './OptionsItemList'
import OptionsPanel from './OptionsPanel'

interface IProps {
  title: string
  children: React.ReactNode

  // Sheets need a close affordance; an anchored popover is dismissed by
  // clicking away and names itself from its trigger, so it omits the header.
  onClose?: () => void
  className?: string
}

const OptionsListPanel: React.FC<IProps> = ({
  title,
  children,
  onClose,
  className,
}) => {
  return (
    <OptionsPanel className={cn('tw:h-full', className)}>
      {!!onClose && <OptionsHeader title={title} onClose={onClose} />}
      <OptionsBody>
        <OptionsItemList>{children}</OptionsItemList>
      </OptionsBody>
    </OptionsPanel>
  )
}

export default OptionsListPanel
